export default function ProfessionalSection() {
  const items = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Éclairage LED intérieur',
      desc: 'Bureaux, commerces, entrepôts — réduisez jusqu\'à 80% votre consommation d\'éclairage avec nos systèmes LED haute efficacité.',
      saving: '-80%',
      image: "https://public.readdy.ai/ai/img_res/73e20084d83d374a6698975a1da1db81.jpg"
    },
    {
      icon: 'ri-building-line',
      title: 'Éclairage LED extérieur',
      desc: 'Parkings, façades, zones logistiques — performances et sécurité renforcées, maintenance drastiquement réduite.',
      saving: '-70%',
      image: "https://readdy.ai/api/search-image?query=Commercial%20building%20exterior%20with%20modern%20LED%20floodlights%20illuminating%20facade%20and%20parking%20area%20at%20twilight%2C%20professional%20outdoor%20lighting%2C%20warm%20amber%20tones%2C%20energy%20efficient%20technology&width=600&height=400&seq=led-ext-v2&orientation=landscape"
    },
    {
      icon: 'ri-plant-line',
      title: 'Déshumidificateurs serres',
      desc: 'Contrôle précis de l\'hygrométrie pour réduire les maladies fongiques et diminuer les coûts de chauffage de vos serres.',
      saving: '-30%',
      image: "https://readdy.ai/api/search-image?query=Large%20modern%20greenhouse%20with%20advanced%20climate%20control%20dehumidifier%20equipment%2C%20lush%20green%20plants%2C%20professional%20agricultural%20technology%2C%20natural%20light%2C%20clean%20industrial%20setting&width=600&height=400&seq=dehumid-v2&orientation=landscape"
    }
  ];

  return (
    <section id="professionnel" className="py-24 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-white/10 text-white text-sm font-bold px-4 py-1.5 rounded-full mb-4">Division Professionnelle</span>
          <h2 className="text-4xl lg:text-5xl font-extrabold text-white mb-4">
            Solutions B2B pour
            <span className="text-emerald-400"> votre entreprise</span>
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto">
            Optimisez vos coûts énergétiques avec des solutions sur-mesure pour les professionnels.
          </p>
        </div>

        {/* Cards */}
        <div className="grid lg:grid-cols-3 gap-6 mb-16">
          {items.map((item, i) => (
            <div key={i} className="bg-slate-800 rounded-2xl overflow-hidden group hover:bg-slate-700 transition-colors duration-300">
              <div className="relative h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-emerald-500 text-white font-black text-xl px-4 py-2 rounded-xl">
                  {item.saving}
                </div>
              </div>
              <div className="p-7">
                <div className="w-10 h-10 bg-slate-700 rounded-xl flex items-center justify-center mb-4">
                  <i className={`${item.icon} text-emerald-400 text-lg`}></i>
                </div>
                <h3 className="text-xl font-extrabold text-white mb-3">{item.title}</h3>
                <p className="text-slate-400 text-sm leading-relaxed mb-5">{item.desc}</p>
                <a href="#contact" className="text-emerald-400 font-semibold text-sm flex items-center gap-1 hover:gap-2 transition-all cursor-pointer">
                  Demander un audit <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="bg-gradient-to-r from-emerald-600 to-teal-600 rounded-3xl p-10 flex flex-col lg:flex-row items-center justify-between gap-8">
          <div className="text-white">
            <p className="text-4xl font-extrabold mb-1">Jusqu'à 80% d'économies</p>
            <p className="text-emerald-100 text-lg">sur vos factures énergétiques dès la première année</p>
          </div>
          <a
            href="#contact"
            className="bg-white text-emerald-700 hover:bg-slate-50 font-bold px-8 py-4 rounded-full transition-colors cursor-pointer whitespace-nowrap"
          >
            Demander un audit énergétique
          </a>
        </div>
      </div>
    </section>
  );
}
